import { createSignal, Show } from "solid-js";
import { Portal } from "solid-js/web";
import { ModalV2Ui, Spinner } from "~/solidJs/shared/ui";

export interface ConnectivityModalMethods {
	show: () => void;
	close: () => void;
}

const [isVisible, setIsVisible] = createSignal(false);

export const showConnectivityModal = () => {
	setIsVisible(true);
};

export const closeConnectivityModal = () => {
	setIsVisible(false);
};

export const ConnectivityModalContent = () => {
	return (
		<Show when={isVisible()}>
			<Portal>
				<ModalV2Ui.ModalWithOverlayBoilerPlate class="min-h-0">
					<ModalV2Ui.ContentContainerText>
						<div class="flex flex-col items-center gap-4">
							<div class="text-center">
								<h1 class="header-30-semibold mb-2 text-text-primary">
									Connection Issues
								</h1>
								<p class="typography-text-14-medium text-text-secondary-v2">
									We're experiencing some connection issues. Please wait while we
									try to reconnect...
								</p>
							</div>
							<Spinner size="large" />
						</div>
					</ModalV2Ui.ContentContainerText>
				</ModalV2Ui.ModalWithOverlayBoilerPlate>
			</Portal>
		</Show>
	);
};

export default ConnectivityModalContent;
